module.exports = __webpack_public_path__ + "img/api-network.30b59d9b.svg";